import { Link } from "react-router-dom";
import { categoryGroups } from "@/mocks/categories";
import { getVideosByType, getSubcategoriesOfType } from "@/utils/video";

const accentMap: Record<string, { border: string; badge: string; icon: string }> = {
  movie: {
    border: "hover:border-primary-400/80",
    badge: "bg-primary-500/15 text-primary-400",
    icon: "bg-primary-500/15 text-primary-400",
  },
  series: {
    border: "hover:border-accent-400/70",
    badge: "bg-accent-500/15 text-accent-300",
    icon: "bg-accent-500/15 text-accent-300",
  },
  short: {
    border: "hover:border-secondary-400/80",
    badge: "bg-secondary-500/20 text-secondary-300",
    icon: "bg-secondary-500/20 text-secondary-300",
  },
};

export default function CategoryShortcuts() {
  return (
    <section className="page-shell py-12 md:py-16">
      <div className="mb-7 flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="mb-2 flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.2em] text-primary-400">
            <span className="h-px w-6 bg-primary-500" />
            Browse by mood
          </p>
          <h2 className="font-heading text-xl font-semibold tracking-tight text-foreground-950 md:text-2xl">
            从三大频道开始，找到此刻想看的内容
          </h2>
        </div>
        <p className="max-w-md text-sm leading-relaxed text-foreground-600">
          电影看沉浸，剧集追长线，短视频随时放松。每一类都按题材细分，几秒就能定位。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
        {categoryGroups.map((group) => {
          const accent = accentMap[group.type];
          const list = getVideosByType(group.type);
          const subs = getSubcategoriesOfType(group.type);
          return (
            <Link
              key={group.type}
              to={`/category/${group.type}`}
              className={`group relative overflow-hidden rounded-lg border border-background-200 bg-background-100 p-5 transition-all duration-300 hover:-translate-y-1 md:p-6 ${accent.border}`}
            >
              <span className="pointer-events-none absolute -right-6 -top-6 flex h-28 w-28 items-center justify-center text-background-300/40">
                <i className={`${group.icon} text-[92px]`} />
              </span>

              <div className="relative flex items-start justify-between">
                <span className={`flex h-11 w-11 items-center justify-center rounded-md ${accent.icon}`}>
                  <i className={`${group.icon} text-xl`} />
                </span>
                <span className={`rounded-full px-2.5 py-1 font-label text-[11px] ${accent.badge}`}>
                  {list.length} 部内容
                </span>
              </div>

              <h3 className="relative mt-5 font-heading text-lg font-semibold text-foreground-950">
                {group.name}
                <span className="ml-2 font-body text-xs font-normal text-foreground-500">
                  {group.tagline}
                </span>
              </h3>

              <p className="relative mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                {group.description}
              </p>

              <div className="relative mt-4 flex flex-wrap gap-1.5">
                {subs.map((sub) => (
                  <span
                    key={sub.id}
                    className="rounded border border-background-200 bg-background-50 px-2 py-1 text-[11px] text-foreground-600"
                  >
                    {sub.name}
                  </span>
                ))}
              </div>

              <span className="relative mt-5 inline-flex items-center gap-1 text-xs text-foreground-500 transition-colors group-hover:text-primary-400">
                进入{group.name}频道
                <i className="ri-arrow-right-line text-sm" />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}